import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import {
    ConfigurationDefaultDeviceConfigurationCreateRequest,
    ConfigurationDefaultDeviceConfigurationResponse
} from '@/modules/configurationModule/detail/instrumentation/devices/services/configuration-default-device-configuration/configuration-default-device-configuration.dto'

class ConfigurationDefaultDeviceConfigurationService {
    async create(laboratoryId: number, request: ConfigurationDefaultDeviceConfigurationCreateRequest): Promise<ConfigurationDefaultDeviceConfigurationResponse> {
        const response = await axios.post<ConfigurationDefaultDeviceConfigurationResponse>(`/configuration/laboratories/${laboratoryId}/defaultDeviceConfiguration`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationDefaultDeviceConfigurationResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationDefaultDeviceConfigurationResponse>>(`/configuration/laboratories/${laboratoryId}/defaultDeviceConfigurations`, { ...filterModel }, { params })
        return response.data
    }

    async delete(laboratoryId: number, defaultDeviceConfigurationId: number): Promise<void> {
        const response = await axios.delete<void>(`/configuration/laboratories/${laboratoryId}/defaultDeviceConfigurations/${defaultDeviceConfigurationId}`)
        return response.data
    }
}

export const configurationDefaultDeviceConfigurationService = new ConfigurationDefaultDeviceConfigurationService()
